import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import './search_commentary_snippet_item.scss';
import { ResultsType } from '../../../../state/reducers/results.types';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';

type Props = {
  commentary: NonNullable<ResultsType['snippets']['commentaries']>[0];
  index: number;
};

export class SearchCommentarySnippetItem extends React.Component<Props> {
  onTitleClicked = () => {
    const { commentary, index } = this.props;
    doctrineAnalytics('Search CommentClicked', {
      source: 'commentaries_snippet',
      reportOriginalQueryKey: true,
      position: index,
      commentaire_id: commentary.commentaireId,
      url: commentary.url,
    });
  };

  onSubTitleClicked = (source: string, value: string) => () => {
    const { commentary } = this.props;
    doctrineAnalytics('Search NoButtonClicked', {
      commentaire_id: commentary.commentaireId,
      source,
      value,
    });
  };

  render() {
    const { commentary } = this.props;
    const { originalDate } = commentary;
    const enhancedUrl = isUrlInternal(commentary.url)
      ? buildUrlWithParameters(commentary.url, {
          source: 'commentary-snippet',
        })
      : commentary.url;
    return (
      <div className="search-commentary-snippet-item">
        <article className="search-commentary-snippet-item__article">
          <Hyperlink
            className="search-commentary-snippet-item__title"
            href={enhancedUrl}
            onClick={this.onTitleClicked}
          >
            <span dangerouslySetInnerHTML={{ __html: commentary.title }} />
            <MaterialIcon
              name="open_in_new"
              className="search-commentary-snippet-item__icon"
            />
          </Hyperlink>
          <div>
            {commentary.author && (
              <span
                onClick={this.onSubTitleClicked(
                  'commentary-snippet-author',
                  commentary.author,
                )}
                className="search-commentary-snippet-item__author"
                dangerouslySetInnerHTML={{ __html: commentary.author }}
              />
            )}

            {commentary.niceSource && (
              <span
                className="search-commentary-snippet-item__source"
                onClick={this.onSubTitleClicked(
                  'commentary-snippet-source',
                  commentary.niceSource,
                )}
              >
                {!!commentary.author && (
                  <span className="search-commentary-snippet-item__separator">
                    <FormattedMessage id="search/components/search-snippets/main/commentary/SearchCommentarySnippetItem.tsx/1" />
                  </span>
                )}
                <span
                  dangerouslySetInnerHTML={{ __html: commentary.niceSource }}
                />
              </span>
            )}

            {originalDate && (
              <span
                className="search-commentary-snippet-item__date"
                onClick={this.onSubTitleClicked(
                  'commentary-snippet-date',
                  originalDate,
                )}
              >
                {(!!commentary.author || !!commentary.niceSource) && (
                  <span className="search-commentary-snippet-item__separator">
                    <FormattedMessage id="search/components/search-snippets/main/commentary/SearchCommentarySnippetItem.tsx/2" />
                  </span>
                )}
                {commentary.originalDate &&
                  formatDateFromNow(commentary.originalDate)}
              </span>
            )}
          </div>
        </article>
      </div>
    );
  }
}
